var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1471 19.563C22.962 20.3787 22.962 21.6994 22.1471 22.5152C21.3313 23.3301 20.0106 23.3301 19.1948 22.5152L11.8367 15.1571C11.6507 14.9702 11.3488 14.9702 11.1628 15.1571L3.80466 22.5152C2.98887 23.3301 1.66817 23.3301 0.852378 22.5152C0.0374884 21.6994 0.0374884 20.3787 0.852378 19.563L8.21054 12.2057C8.39741 12.0188 8.39741 11.717 8.21054 11.531L0.852378 4.17282C0.0374884 3.35704 0.0374884 2.03633 0.852378 1.22054C1.66817 0.405652 2.98887 0.405652 3.80466 1.22054L11.1628 8.57962C11.3488 8.7656 11.6507 8.7656 11.8367 8.57962L19.1948 1.22054C20.0106 0.405652 21.3313 0.405652 22.1471 1.22054C22.962 2.03633 22.962 3.35704 22.1471 4.17282L14.7889 11.531C14.6021 11.717 14.6021 12.0188 14.7889 12.2057L22.1471 19.563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4fab8a71c9e8dc011381bdfadf3703f0.svg";
export { ForwardRef as ReactComponent };